<template>
    <div class="inner dashboard">

        <FinishProfile v-on:done="show_finish_profile = false; is_profile_completed = true;"
                       v-if="(!is_profile_completed || show_finish_profile) && getTenantAccess === null"/>

        <div class="headline">
            <h1>{{ $t('dashboard.headline') }}</h1>
        </div>
        <div class="content-box">
            <div class="container">
                <h2>
                    {{ $t('dashboard.welcome') }}!
                </h2>
                <p v-if="getTenantAccess === null">{{ $t('dashboard.welcome-text') }}</p>

                <div class="boxes four" :class="subscriptionIsUpgradeable ? 'not-upgraded': 'upgraded'">
                    <router-link
                        to="#"
                        :key="index"
                        v-for="(cols, index) in dashboard"
                        v-if="cols.display"
                        class="col"
                        v-bind:class="{ locked: cols.itemLocked }"
                        disabled
                    >
                        <div class="content">
                            <div class="icon">
                                <img :src="cols.icon">
                            </div>
                            <h3>{{ $t(cols.translationId) }}</h3>
                            <p>{{ $t(cols.translationDesc) }}</p>
                        </div>
                        <div class="info" v-if="cols.col == 'screening'">
                            <!-- Insert screening price -->
                            <p>{{ cols.count }} {{ $t(cols.translationDescOne) }}</p>
                        </div>
                        <div class="info" v-else-if="cols.col == 'digital-contract' && !subscriptionIsUpgradeable">
                            <p>{{ $t('dashboard.col.three.desc-intro') }} {{
                                    $t('dashboard.col.contracts.unlimited')
                                }}</p>
                        </div>
                        <div class="info" v-else-if="cols.col == 'digital-contract' && subscriptionIsUpgradeable">
                            <p v-if="cols.count == '1'">{{ $t('dashboard.col.three.desc-intro') }} {{ cols.count }}
                                {{ $t(cols.translationDescOne) }}</p>
                            <p v-else>{{ $t('dashboard.col.three.desc-intro') }} {{ cols.count }}
                                {{ $t(cols.translationDescTwo) }}</p>
                        </div>
                        <div class="info" v-else>
                            <p v-if="cols.count == '1'">{{ cols.count }} {{ $t(cols.translationDescOne) }}</p>
                            <p v-else>{{ cols.count }} {{ $t(cols.translationDescTwo) }}</p>
                        </div>
                    </router-link>
                    <router-link to="/user/settings#abonnement" v-if="getTenantAccess === null && subscriptionIsUpgradeable" class="col locked">
                        <div class="content">
                            <div class="icon">
                                <img src="images/img/dashboard/upgrade.png">
                            </div>
                            <h3>{{ $t('dashboard.col.locked.text') }}</h3>
                            <p>{{ $t('dashboard.col.locked.desc') }}</p>
                            <router-link to="/user/settings#abonnement" class="button white">
                                {{ $t('button.label.learn-more') }}
                            </router-link>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {mapGetters} from 'vuex';

import InlineLoader from '../components/InlineLoader.vue';
import SvgIcon from '../components/Svg.vue';
import FinishProfile from '../components/FinishProfile.vue';
import createEntity from "../mixins/create-entity";

export default {
    mixins: [createEntity],
    components: {
        InlineLoader,
        SvgIcon,
        FinishProfile,
    },
    data: () => ({
        show_finish_profile: false,
        free_contracts: '',
        screening_price: '',
        has_unsigned_contracts: false,
        has_invitation: false,
        properties: '',
        is_profile_completed: true,
    }),
    mounted() {
        window.scrollTo(0, 0)
    },
    computed: {
        ...mapGetters([
            'getToken',
            'subscriptionIsUpgradeable',
            'subscriptionHasLegacyContracts',
            'getFullNameNoFallback',
            'hasLimitedAccess',
            'tenantHasScreeningAccess',
            'getSentInvitations',
            'subscriptionIsUnlimited',
            'getTenantAccess'
        ]),
        name() {
            if (!this.getFullNameNoFallback || this.getFullNameNoFallback == '-') {
                return '';
            }
            let parts = this.getFullNameNoFallback.split(' ');
            return parts[0];
        },
        dashboard() {

            let landlordControls = [
                {
                    col: 'property',
                    link: '/properties/add',
                    svgIcon: 'images/SVG/Dashboard/Property.svg',
                    icon: 'images/img/dashboard/property.png',
                    translationId: 'dashboard.col.one.text',
                    translationDesc: 'dashboard.col.one.description',
                    translationDescOne: 'dashboard.col.one.desc-one',
                    translationDescTwo: 'dashboard.col.one.desc-two',
                    count: this.properties,
                    display: true,
                },
                {
                    col: 'screening',
                    link: '/screenings/select-property',
                    svgIcon: 'images/SVG/Dashboard/Screening.svg',
                    icon: 'images/img/dashboard/screening.png',
                    translationId: 'dashboard.col.two.text',
                    translationDesc: 'dashboard.col.two.description',
                    translationDescOne: 'DKK',
                    count: this.screening_price,
                    display: true,
                },
                {
                    col: 'digital-contract',
                    link: '/contracts/digital-contract/select-property',
                    svgIcon: 'images/SVG/Dashboard/Contract.svg',
                    icon: 'images/img/dashboard/digital-contract.png',
                    translationId: 'dashboard.col.three.text',
                    translationDesc: 'dashboard.col.three.description',
                    translationDescOne: 'dashboard.col.three.desc-one',
                    translationDescTwo: 'dashboard.col.three.desc-two',
                    count: this.subscriptionIsUnlimited ? 0 : this.free_contracts,
                    display: true,
                },
            ];

            let tenantScreeningControl =
                // Tenants buttons
                {
                    translationId: 'tenant.dashboard.col-one',
                    translationDesc: 'tenant.dashboard.col-one-text',
                    svgIcon: 'images/SVG/Dashboard/Screening.svg',
                    icon: 'images/img/dashboard/screening.png',
                    iconHeight: '131.5px',
                    iconWidth: '168.5px',
                    link: '/tenant-screening',
                    display: this.has_invitation
                };

            let tenantContractControl =
                {
                    translationId: 'tenant.dashboard.col-two',
                    translationDesc: 'tenant.dashboard.col-two-text',
                    svgIcon: 'images/SVG/Dashboard/Contract.svg',
                    icon: 'images/img/dashboard/digital-contract.png',
                    iconHeight: '128px',
                    iconWidth: '146.5px',
                    link: '/contracts',
                    display: true
                };


            if (this.getTenantAccess === null) {
                return landlordControls;
            }

            if(this.getTenantAccess === 'both') {
                return [tenantScreeningControl, tenantContractControl];
            }

            if(this.getTenantAccess === 'screening') {
                return [tenantScreeningControl];
            }

            if(this.getTenantAccess === 'contract') {
                return [tenantContractControl];
            }

        }
    },
    methods: {
        load() {

            Vue.api.get('/user/dashboard', {}, {
                callback: (data) => {
                    this.properties = data.properties;
                    this.screening_price = data.screening_price;
                    this.free_contracts = data.free_contracts;
                    this.has_unsigned_contracts = data.has_unsigned_contracts;
                    this.has_invitation = data.has_invitation;
                    this.is_profile_completed = data.is_profile_completed;
                },
            });

        },
    },
    created() {
        if (this.hasLimitedAccess) {
            this.$router.push('/contracts');
        }
        this.load();

        this.$store.dispatch('fetchUserSubscription');
    }
}
</script>
<style>
</style>
